export const orders = [
    { "id": 1, "value": "Lệnh MUA" },
    { "id": 2, "value": "Lệnh BÁN" },
    { "id": 3, "value": "Lệnh CHỜ MUA" },
    { "id": 4, "value": "Lệnh CHỜ BÁN" }
]